import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { SetBetData, SetBetType } from "../../common/actions/miniAction";
import {
  getMinigameUrl,
  isEmpty,
  no_comma,
  ResizeGopickFrame,
  ResizePowerballFrame,
  toastr,
  convertMinigameName
} from "../../common/cores";
import { socket } from "../../common/cores/socket";
import { getgameGrps, prices } from "../../utils/names";
import EOSPanel from "./EOSPanel";
import MinigameVideo from "./MinigameVideo";

const powerBalls = [
  {
    name: "EOS 파워볼 1분",
    value: 1
  },
  {
    name: "EOS 파워볼 2분",
    value: 2
  },
  {
    name: "EOS 파워볼 3분",
    value: 3
  },
  {
    name: "EOS 파워볼 4분",
    value: 4
  },
  {
    name: "EOS 파워볼 5분",
    value: 5
  }
];
const MinigameCenter = props => {
  const { type, rates, state, miniCheck } = props;
  ResizePowerballFrame();
  ResizeGopickFrame();

  const [money, setMoney] = useState(0);
  const [powerBalltype, setPowerBalltype] = useState(1);
  const [beted, setBeted] = useState({});
  const [url, setUrl] = useState("");

  const onClickBetButton = (odd_key, bet_Rate, name) => {
    let data = {
      odd_key: odd_key,
      rate: bet_Rate,
      name: name
    };
    setBeted(data);
    props.SetBetData(data);
  };
  const onChange = e => {
    const { value } = e.target; // 우선 e.target 에서 name 과 value 를 추출
    console.log(isNaN(Number(no_comma(value))));
    if (!isNaN(Number(no_comma(value)))) setMoney(Number(no_comma(value)));
    else setMoney(0);
  };

  const roomObj = {
    pageType: "EOSPowerball" + powerBalltype,
    sportType: "all",
    gameType: "all",
    sportId: "all"
  };

  // const gameGrps = this.state.gameGrps;

  const ballPrice = [
    rates.normal.evenOdd,
    rates.normal.evenOdd,
    rates.normal.overUnder,
    rates.normal.overUnder,
    rates.normal.big,
    rates.normal.medium,
    rates.normal.small,
    rates.power.evenOdd,
    rates.power.evenOdd,
    rates.power.overUnder,
    rates.power.overUnder
  ];
  const DoBetting = () => {
    if (!props.user.isAuthenticated)
      return toastr.warning("로그인하시고 이용해주세요.");
    setMoney(0);
    props.DoBetting(money);
  };

  useEffect(
    () => {
      if (type === "eos_powerball") {
        const miniData = {
          pageType: 'EOSPowerball' + powerBalltype,
          RoomType: 'EOSPowerball' + powerBalltype,
          sportType: 'all',
          gameType: 'all',
          sportId: 'all',
        }
        const roomData = {
          MessageType: "RoomType",
          data: miniData
        };
        if(window.ws.readyState === 1)
          window.ws.send(JSON.stringify(roomData));
        props.SetBetType(powerBalltype);
      } else {
        const miniData = {
          pageType: type,
          RoomType: type,
          sportType: 'all',
          gameType: 'all',
          sportId: 'all',
        }
        const roomData = {
          MessageType: "RoomType",
          data: miniData
        };
        if(window.ws.readyState === 1)
          window.ws.send(JSON.stringify(roomData));
        props.SetBetType(type);
      }
    },
    [powerBalltype, type]
  );

  const getMinigamePanel = type => {
    const gameGrps = getgameGrps(type);
    const ballPrice = prices(type, rates);

    return <EOSPanel gameGrps={gameGrps} ballPrice={ballPrice} money={money} />;
  };

  const getMinigameVideo = type => {
    console.log(url);
    switch (type) {
      case "eos_powerball":
        return <MinigameVideo type={powerBalltype} url={url} />;

      default:
        return <MinigameVideo type={type} url={url} />;
    }
  };

  useEffect(
    () => {
      let param = "";
      if (type === "eos_powerball") {
        param = powerBalltype;
        // console.log( getMinigameUrl(powerBalltype))
      } else {
        param = props.type;
        // console.log('----------------------------------',  getMinigameUrl(props.type))
      }
      getMinigameUrl(param)
        .then(url => setUrl(url))
        .catch(err => console.log(err));
      // setUrl(murl);
    },
    [type, powerBalltype]
  );

  const getMinigameTab = type => {
    switch (type) {
      case "eos_powerball":
        return (
          <div className="con_box00">
            <div
              className="s_tab_wrap"
              style={{ width: "100%", overflow: "auto" }}
            >
              <ul style={{ display: "flex", height: "45px" }}>
                {powerBalls.map((list, index) => {
                  return (
                    <li
                      className={`event column cursor-point ${
                        index + 1 === powerBalltype ? "active" : ""
                      }`}
                      onClick={() => setPowerBalltype(list.value)}
                      key={index}
                    >
                      <a>
                        <span
                          className={` ${
                            index + 1 === powerBalltype ? "s_tabon" : "s_tab"
                          }`}
                        >
                          <img src="../images/powerball.svg" alt="" /> &nbsp;
                          {list.name}{" "}
                        </span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        );

      default:
        return "";
    }
  };

  return (
    <div className="contents_box_left" style={{ position: "relative" }}>
      {getMinigameTab(type)}
      {/* {getMinigamePanel(type)} */}
      <div className="mini_title_wrap" style={{ marginTop: "10px" }}>
        <div className="mini_title">
          {convertMinigameName(type === "eos_powerball" ? powerBalltype : type)}{" "}
          &nbsp;&nbsp;
          <span className="mini_round">
            <span>{ isNaN(state.round) ? 0 : Number(state.round).toLocaleString()}</span> 회차
          </span>
        </div>
      </div>
      {/* <div style="height:500px;background:#000000;">영상구역</div>  */}
      <div className="mini_game_wrap">
        <div style={{ width: "100%" }}>{getMinigameVideo(type)}</div>
        {getMinigamePanel(type)}
      </div>
      <div
        data-v-57f1e9d9=""
        className="mini_bet_close"
        style={{ display: miniCheck ? "none" : "" }}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  betted: state.mini.data,
  rates: state.mini.rates,
  state: state.mini.state,
  miniCheck: state.mini.miniCheck,
  user: state.user
});

export default connect(
  mapStateToProps,
  { SetBetData, SetBetType }
)(MinigameCenter);



// WEBPACK FOOTER //
// ./src/components/Minigame/MinigameCenter.js